import {PurchaseOrdering} from 'web-app/util/graphql/api-types';

export type PURCHASE_STATUS = 'PENDING' | 'APPROVED' | 'REJECTED';

export const defaultPurchaseOrdering = PurchaseOrdering.ByCreation;
